import React from 'react';
import { Table, Tooltip, Typography } from 'antd';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { renderActivityType } from '@/constants/zongcu';
import './index.less';
import { Link } from 'react-router-dom';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import Dongdong from '@/components/dongdong';
import { useHistory, matchPath } from 'react-router-dom';
import Empty from '@/components/core-empty';
import ComponentLog from '@/components/component-log';
import moment from 'moment';
import useTemplateSchema, { couponLevelSettingTemplateId } from './useTemplateSchema';

const applyTagTxt = ['', '店铺维度', 'SKU维度'];

export const couponLevelMap = {
  1: {
    text: '第一层级',
    color: 'red',
  },
  2: {
    text: '第二层级',
    color: 'orange',
  },
  3: {
    text: '第三层级',
    color: 'blue',
  },
  4: {
    text: '第四层级',
    color: 'green',
  },
  5: {
    text: '第五层级',
    color: 'green',
  },
};

// 商城体系展示的层级
export const couponLevelDesEleByIsMallSystem = (
  <React.Fragment>
    <div>优惠券层级概念：</div>
    <div>当前京东体系内东券优惠券共分层为五级，不同层级之间可进行叠加，同层级不可叠加</div>
    <div>其中一层级为：POP店铺券、自营店铺券</div>
    <div>二层级为：跨品类券</div>
    <div>三层级为：大促惊喜券，仅在大促活动期间开放平台大促使用</div>
    <div>四层级为：平台补贴券（PLUS超级补贴）</div>
    <div>五层级为：单品券</div>
    <div>优惠券与促销之间叠加不受影响</div>
  </React.Fragment>
);

// 非商城体系展示的层级
export const couponLevelDesEle = (
  <React.Fragment>
    <div>优惠券层级概念：</div>
    <div>当前京东体系内东券优惠券共分层为四级，不同层级之间可进行叠加，同层级不可叠加</div>
    <div>其中一层级为：POP店铺券、自营店铺券、限品类券</div>
    <div>二层级为：大促神券</div>
    <div>三层级为：大促惊喜券，仅在大促活动期间开放平台大促使用</div>
    <div>四层级为：平台补贴券（PLUS超级补贴）</div>
    <div>优惠券与促销之间叠加不受影响</div>
  </React.Fragment>
);

export const promoTypeLevelSignStrMap = {
  1: {
    label: '品类/事业群总促',
    tooltips:
      '24年促销简化项目最新方向，新版本总价促销为“品类/事业群总促”，与店铺级总促（商家自己创建）和平台级总促（大促跨店满减）在前台互斥，消费者下单时仅能使用一个',
  },
  2: {
    label: '普通总价促销',
    tooltips: '多个普通的总价促销之间互斥，消费者下单时仅能使用一个，但普通总价促销可与大促跨店满减叠加',
  },
  3: {
    label: '平台级总促',
    tooltips:
      '24年促销简化项目最新方向，新版本大促跨店满减为“平台级总促”，与店铺级总促（商家自己创建）和品类/事业群总促（采销运营等在营销中心、促销中心创建）在前台互斥，消费者下单时仅能使用一个',
  },
  4: {
    label: '大促跨店满减',
    tooltips: '大促跨店满减生效层级高于普通总价促销，消费者下单时可与普通总价促销叠加',
  },
};

export default (props) => {
  const {
    data = {},
    conditions = {},
    setConditions = () => {},
    toTB = () => {},
    flag = '',
    forbidOperate = false,
  } = props;
  const history = useHistory();
  const pathnameList = history.location.pathname.split('/');
  const lastPath = pathnameList[pathnameList.length - 1];
  const mallSystemConfig = useTemplateSchema({ templateId: couponLevelSettingTemplateId });
  const { settingContent } = mallSystemConfig;

  const log = (id) => {
    let zongcutab = '0';
    if (lastPath === 'myJoin') {
      zongcutab = '0';
    }
    if (lastPath === 'myCreate') {
      zongcutab = '1';
    }
    if (lastPath === 'myManage') {
      zongcutab = '2';
    }
    window.log && window.log('yx_center', 'zongcuactivityclick', `{"activityid":"${id}","zongcutab":"${zongcutab}"}`);
  };

  const htmlHasContent = (html) => {
    // 去除HTML标签
    if (!html) return false;
    const text = html.replace(/<[^>]*>/g, '').trim();
    return text.length > 0;
  };

  const getCouponLevelElement = (baseInfo = {}) => {
    const { couponLevel, activityType, extMap } = baseInfo;
    const { COUPON_ORG_TYPE } = extMap || {};
    if (activityType !== 108 || !couponLevel) return null;
    const LevelObj = couponLevelMap[couponLevel] || { text: '-', color: 'black' };
    return (
      <span style={{ padding: '0 16px' }}>
        优惠券层级标识{' '}
        <Tooltip
          title={
            COUPON_ORG_TYPE === '2'
              ? couponLevelDesEleByIsMallSystem
              : htmlHasContent(settingContent) && (
                  <div className="common-setting-content" dangerouslySetInnerHTML={{ __html: settingContent }} />
                )
          }
          arrowPointAtCenter
        >
          <InfoCircleOutlined />
        </Tooltip>
        <span style={{ color: LevelObj.color }}>：{LevelObj.text}</span>
      </span>
    );
  };

  const getPromoTypeLevelSignElement = (baseInfo = {}) => {
    const { extMap, activityType } = baseInfo;
    const { PROMO_TYPE_LEVEL_SIGN } = extMap || {};
    if (![115, 119].includes(activityType) || !PROMO_TYPE_LEVEL_SIGN) return null;
    const signObj = promoTypeLevelSignStrMap[PROMO_TYPE_LEVEL_SIGN] || {};
    return (
      <span style={{ padding: '0 16px' }}>
        促销类型及层级标识
        {PROMO_TYPE_LEVEL_SIGN != 3 && (
          <Tooltip title={signObj.tooltips} arrowPointAtCenter>
            <InfoCircleOutlined />
          </Tooltip>
        )}
        <span style={{ color: 'red' }}>：{signObj.label}</span>
      </span>
    );
  };

  data.list.forEach((item) => (item.key = item.id));

  const commonColumns = [
    {
      title: '活动信息',
      dataIndex: 'info',
      key: 'info',
      fixed: 'left',
      width: 330,
      render: (value, baseInfo) => {
        const strategyId = baseInfo?.zongcuStategy ? baseInfo.strategyId : null; // 综促策略id
        const { extMap } = baseInfo;
        const { PROMO_TYPE_LEVEL_SIGN } = extMap || {};
        return (
          <div className="base-info-fa">
            <div style={{ display: 'flex' }}>
              <div className="base-activity-name">
                <span
                  title={baseInfo?.name || ''}
                  onClick={() =>
                    !forbidOperate &&
                    toTB(
                      baseInfo?.zongcuStategy ? baseInfo.outerActivityId : baseInfo.id,
                      baseInfo?.zongcuStategy ? baseInfo.applyValidStatus : baseInfo.activityStatus
                    )
                  }
                >
                  {baseInfo?.name || ''}
                </span>
              </div>
              {lastPath === 'myJoin' && PROMO_TYPE_LEVEL_SIGN === '1' && (
                <img
                  style={{ marginLeft: 4, cursor: 'pointer' }}
                  width={84}
                  onClick={() =>
                    window.open('https://joyspace.jd.com/pages/DUW39DUzYwoR8nVFT5M4', '_blank', 'noopener, noreferrer')
                  }
                  src="//img30.360buyimg.com/pop/jfs/t1/189608/8/52399/4304/673d5ca8Fa632dd70/7e4e2ebf9f31f8b6.png"
                />
              )}
            </div>
            <div className="base-activity-id-fa">
              {baseInfo.isRelated == 1 && <div className="activity-isRelated">主题活动</div>}
              <div className="activity-type">{renderActivityType(baseInfo.activityType).name}</div>
              {getCouponLevelElement(baseInfo)}
              {getPromoTypeLevelSignElement(baseInfo)}
              {!!baseInfo.crossProduct && <div className="activity-type">跨品类营销</div>}
            </div>
            <div style={{ fontSize: '12px', marginTop: '6px' }}>
              {baseInfo?.zongcuStategy ? '策略ID：' : '活动编号：'}
              {strategyId ||
                baseInfo?.macActId ||
                (baseInfo?.id && (
                  <Typography.Paragraph
                    style={{ marginBottom: 0, lineHeight: '20px' }}
                    copyable={{
                      text: `${strategyId || baseInfo?.macActId || baseInfo?.id || ''}`,
                      icon: <CopyOutlined style={{ color: 'rgba(0, 0, 0, 0.65)' }} />,
                    }}
                  >
                    <span className="base-activity-id">
                      <span>{strategyId || baseInfo?.macActId || baseInfo?.id || ''}</span>
                    </span>
                  </Typography.Paragraph>
                ))}
            </div>
          </div>
        );
      },
    },
    {
      title: '活动时间',
      dataIndex: 'activityTime',
      key: 'activityTime',
      width: 160,
      render: (value, baseInfo) => {
        return (
          <div className="activity-time-fa">
            <div className="activity-time-begin">
              {baseInfo?.beginTime
                ? enhancedFormateTimeStamp(moment(baseInfo.beginTime).valueOf(), 'YY-MM-DD hh:mm:ss')
                : ''}
              <br />
              {baseInfo?.beginTime && baseInfo?.endTime ? '~' : '-'}
              <br />
            </div>
            <div className="activity-time-end">
              {baseInfo?.endTime
                ? enhancedFormateTimeStamp(moment(baseInfo.endTime).valueOf(), 'YY-MM-DD hh:mm:ss')
                : ''}
            </div>
          </div>
        );
      },
    },
    {
      title: '报名时间',
      width: 160,
      dataIndex: 'activityApplyTime',
      key: 'activityApplyTime',
      render: (value, baseInfo) => {
        return (
          <div className="activity-apply-time-fa">
            <div className="activity-apply-time-begin">
              {baseInfo?.applyBeginTime
                ? enhancedFormateTimeStamp(moment(baseInfo.applyBeginTime).valueOf(), 'YY-MM-DD hh:mm:ss')
                : ''}
              <br />
              {baseInfo?.applyBeginTime && baseInfo?.applyEndTime ? '~' : '-'}
              <br />
            </div>
            <div className="activity-apply-time-end">
              {baseInfo?.applyEndTime
                ? enhancedFormateTimeStamp(moment(baseInfo.applyEndTime).valueOf(), 'YY-MM-DD hh:mm:ss')
                : ''}
            </div>
          </div>
        );
      },
    },
    {
      title: '创建时间',
      width: 160,
      dataIndex: 'created',
      key: 'created',
      render: (value, baseInfo) => {
        return (
          <div className="activity-apply-time-fa">
            <div className="activity-apply-time-end">
              {baseInfo?.created
                ? enhancedFormateTimeStamp(moment(baseInfo.created).valueOf(), 'YY-MM-DD hh:mm:ss')
                : '-'}
            </div>
          </div>
        );
      },
    },
    {
      title: '报名方式',
      dataIndex: 'applyTag',
      key: 'applyTag',
      width: 160,
      render: (value, baseInfo) => {
        return (
          <div className="activity-apply-time-fa">
            <div className="activity-apply-time-end">{baseInfo?.zongcuStategy ? applyTagTxt[value] : value}</div>
          </div>
        );
      },
    },
    {
      title: '活动创建人',
      dataIndex: 'erpPin',
      key: 'erpPin',
      width: 160,
      render: (value, baseInfo) => {
        return <Dongdong name={value} erp={value} />;
      },
    },

    {
      title: '活动状态',
      key: 'applyStatus',
      dataIndex: 'applyStatus',
      fixed: 'right',
      width: 125,
      render: (value) => {
        switch (value && value.toString()) {
          case '1':
            return <span className="zongcu-status-red">待报名</span>;
          case '2':
            return <span className="zongcu-status-green">已报名</span>;
          case '3':
            return <span className="zongcu-status-grey">报名结束</span>;
          default:
            return '-';
        }
      },
    },
    {
      title: '活动状态',
      key: 'actStatus',
      dataIndex: 'actStatus',
      fixed: 'right',
      width: 125,
      render: (value) => {
        switch (value && value.toString()) {
          case '1':
            return <span className="zongcu-status-green">报名中</span>;
          case '2':
            return <span className="zongcu-status-red">待发布</span>;
          case '3':
            return <span className="zongcu-status-green">已发布</span>;
          case '4':
            return <span className="zongcu-status-grey">报名结束</span>;
          default:
            return '-';
        }
      },
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 125,
      render: (value, baseInfo) => {
        if (forbidOperate) return null;
        switch (baseInfo?.activityStatus?.toString()) {
          case '2':
            return (
              <ComponentLog clstag="yx_center_onsale_1712819613846|2">
                <a
                  onClick={() =>
                    toTB(
                      baseInfo?.zongcuStategy ? baseInfo.outerActivityId : baseInfo.id,
                      baseInfo.activityStatus,
                      baseInfo.activityType
                    )
                  }
                  style={{ padding: '30px 0' }}
                >
                  立即报名
                </a>
              </ComponentLog>
            );
          default:
            return (
              <a
                onClick={() => {
                  log(baseInfo.id);
                  toTB(
                    baseInfo?.zongcuStategy ? baseInfo.outerActivityId : baseInfo.id,
                    baseInfo.activityStatus,
                    baseInfo.activityType
                  );
                }}
                style={{ padding: '30px 0' }}
              >
                进入活动
              </a>
            );
        }
      },
    },
  ];

  const getColumns = () => {
    if (flag == 'join') {
      const aaa = commonColumns.filter((item) => item.key !== 'actStatus');
      return Object.assign([], aaa);
    } else {
      const aaa = commonColumns.filter((item) => item.key !== 'applyStatus' && item.key !== 'erp');
      return Object.assign([], aaa);
    }
  };

  return (
    <div className="zongcu-list-table-fa">
      <Table
        scroll={{ x: 1300 }}
        loading={data.loading}
        columns={getColumns()}
        rowKey={({ baseInfo }) => baseInfo?.id}
        dataSource={data.list}
        // onChange={onTableChange}
        rowClassName={() => 'activity-list-row-custom'}
        pagination={{
          ...conditions,
          current: conditions.currentPage,
          total: data.totalCount,
          showSizeChanger: false,
          showTotal: (total) => `总共${total}条`,
          onChange: (page) => setConditions({ ...conditions, currentPage: page }),
        }}
        locale={{
          emptyText: <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />,
        }}
      />
    </div>
  );
};
